import * as React from "react";


export interface ITab {
    id: number;
    title?: string;
    subTitle?: string;
    className?: string;
}

export default class Tab extends React.Component<ITab> {

    render(){
        return (
            <div className={this.props.className}>{this.props.children}</div>
        )
    }
}